import { Component, OnDestroy, OnInit } from '@angular/core';
import { Store } from '../../store';
import { OverlayService } from '../../services/overlay.service';
import { NavigationEnd, Router } from '@angular/router';
import { SeoService } from '../../services/seo.service';
import { CmsService } from '../../services/cms.service';
import { MenuService } from '../../services/menu.service';
import { Title } from '@angular/platform-browser';
import { filter } from 'rxjs/operators';

@Component({
    selector: 'app-default-layout',
    templateUrl: './default-layout.component.html',
    styleUrls: ['./default-layout.component.scss']
})
export class DefaultLayoutComponent implements OnInit, OnDestroy {
    title = 'public';
    overlays$ = this.store.select<any>('overlays');
    isMobile = true;
    innerWidth$ = this.store.select<number>('innerWidth');
    deviceType$ = this.store.select<string>('deviceType');
    page;
    pageSnippets = [];

    mobileMenu$ = this.store.select<boolean>('mobileMenu');
    mobileMenuUser$ = this.store.select<boolean>('mobileMenuUser');
    routerObserver;
    hasLoaded = false;

    constructor(
        private store: Store,
        private overlayService: OverlayService,
        private router: Router,
        private seoService: SeoService,
        private cmsService: CmsService,
        private menuService: MenuService,
        private titleService: Title,
    ) {
        this.routerObserver = this.router.events.pipe(
            filter(event => event instanceof NavigationEnd)
        ).subscribe((event: NavigationEnd) => {
            let activeRoute = event.url.replace(/^\/|\/$/g, '');
            if (activeRoute === '') {
                activeRoute = 'home';
            }
            if (activeRoute.charAt(0) === '?') {
                activeRoute = 'our-town';
            }
            this.getPage(activeRoute.replace(/\//g, '-'));

            this.getPageContent(activeRoute.replace(/\//g, '-'));
            this.menuByRoute(activeRoute.replace(/\//g, '-'));
        });
    }

    ngOnInit(): void {
        this.cmsService.getSettings().subscribe();
        this.menuService.menuGroups();
    }

    ngOnDestroy() {
        this.routerObserver.unsubscribe();
    }

    menuByRoute(route) {
        this.menuService.menuByRoute(route);
    }

    getPage(route) {
        this.cmsService.page(route).subscribe(data => {
            this.page = data;
            this.getPageSnippets(route);
        })
    }
    getPageSnippets(route) {
        this.cmsService.pageSnippets(route).subscribe(data => {
            this.pageSnippets = data;
            this.hasLoaded = true;
        })
    }

    getPageContent(route) {
        const routeToFind = route.split('?')[0];
        const pages = this.store.selectForLocal('pages');
        if (pages) {
            this.page = pages[routeToFind];
            if (this.page) {
                this.titleService.setTitle(this.page.metaTitle);
                this.seoService.addMetaTag('description', this.page.metaDescription);
                this.seoService.createLinkForCanonicalURL();
                // this.seoService.updateMetaTags('og:title', this.page.metaTitle);
                // this.seoService.updateMetaTags('og:description', this.page.metaDescription);
            }
        }
    }
}
